import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import axios from '../../services/axios';
import { Container, Form } from '../../styles/GlobalStyles';
import {
  DescricaoQuestao, Proxima, AlternativaCompleta,
  Title, Questoes, TitleDisciplina,
} from './styled';
import Loading from '../Loading';

export default function VisualizarProva({ disciplinas, disciplina }) {
  const [isLoading, setIsLoading] = useState(false);
  const [numberQuestao, setNumberQuestao] = useState(1);
  const [questao, setQuestao] = useState('');
  const [alternativas, setAlternativas] = useState([]);
  const [resposta, setResposta] = useState('');
  const [questoes, setQuestoes] = useState();
  const [provas, setProvas] = useState(0);
  const [descricaoDisciplina, setDescricaoDisciplina] = useState('');

  useEffect(() => {
    const renderProvas = () => {
      if ((disciplinas.length > provas && disciplinas[provas].id
      && disciplinas.length !== provas)) {
        axios(`/questoes/${disciplinas[provas].id}/${numberQuestao}`)
          .then((response) => {
            setQuestoes(Number(disciplinas[provas].quantidade_questoes));
            setQuestao(response.data.descricao_questao);
            setDescricaoDisciplina(disciplinas[provas].descricao_disciplina);
            return response.data.id;
          }).then(
            (respon) => (
              axios(`/alternativas/${respon}`))
              .then((res) => {
                const data = res.data.alternativas;
                setResposta(res.data.resposta_correta);
                setAlternativas([...Object.values(data)]);
                setIsLoading(false);
              }).catch((err) => {
                setIsLoading(false);
                toast.error('Não foi possível carregar as alternativas');
              }),
          ).catch((err) => {
            setIsLoading(false);
            toast.error('Não foi possível carregar a prova');
          });
      } else if (disciplina.id) {
        axios(`/questoes/${disciplina.id}/${numberQuestao}`)
          .then((response) => {
            setQuestoes(Number(disciplina.quantidade_questoes));
            setQuestao(response.data.descricao_questao);
            return response.data.id;
          }).then(
            (respon) => (
              axios(`/alternativas/${respon}`))
              .then((res) => {
                const data = res.data.alternativas;
                setResposta(res.data.resposta_correta);
                setAlternativas([...Object.values(data)]);
                setIsLoading(false);
              }).catch((err) => {
                setIsLoading(false);
                toast.error('Não foi possível carregar as alternativas');
              }),
          ).catch((err) => {
            setIsLoading(false);
            toast.error('Não foi possível carregar a prova');
          });
      }
    };

    renderProvas();
  }, [numberQuestao, disciplinas, provas, disciplina]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (numberQuestao < questoes) {
      setNumberQuestao(numberQuestao + 1);
    }

    if (numberQuestao === questoes && !disciplina.id) {
      if (disciplinas.length > provas) {
        setProvas(provas + 1);
        setNumberQuestao(1);
      }
    }
  };

  return (
    <Container>

      <Loading isLoading={isLoading} />

      <TitleDisciplina>
        {descricaoDisciplina}
      </TitleDisciplina>

      <Title>
        Questão
        {' '}
        {numberQuestao}
      </Title>

      <Form onSubmit={(e) => handleSubmit(e)}>
        <DescricaoQuestao>{questao}</DescricaoQuestao>

        <Questoes>
          {alternativas.map((alternativa) => (
            <AlternativaCompleta
              className={resposta === alternativa ? 'correct' : ''}
              key={uuidv4()}
            >
              <p>{alternativa}</p>
            </AlternativaCompleta>
          ))}
        </Questoes>

        <Proxima>
          {((numberQuestao === questoes && disciplinas.length === provas + 1)
          || (numberQuestao === questoes && disciplina.id))
            ? (<Link to="/">Finalizar</Link>) : (
              <button type="submit">
                Próxima
              </button>
            )}
        </Proxima>
      </Form>

    </Container>
  );
}

VisualizarProva.defaultProps = {
  disciplinas: [],
  disciplina: {},
};

VisualizarProva.propTypes = {
  disciplinas: PropTypes.arrayOf(PropTypes.shape({
    descricao_disciplina: PropTypes.string,
    id: PropTypes.number,
    id_disciplina_mesma_prova: PropTypes.string,
    id_identificacao_empresa: PropTypes.number,
    quantidade_questoes: PropTypes.string,
    utilizar_mesma_prova: PropTypes.string,
  })),
  disciplina: PropTypes.shape({
    curso_nivel: PropTypes.string,
    descricao_disciplina: PropTypes.string,
    id: PropTypes.number,
    id_disciplina_mesma_prova: PropTypes.string,
    id_identificacao_empresa: PropTypes.number,
    quantidade_questoes: PropTypes.string,
    tipos_de_prova: PropTypes.string,
    utilizar_mesma_prova: PropTypes.string,
  }),
};
